import {
    FETCH_FLOW24_SERVER_CONFIG
} from "../actions/actionTypes";

const defaultState = {
    //konfiguracja servera flow24
    config: {}
};

export default function flow24ServerReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_FLOW24_SERVER_CONFIG: {
            return {
                ...state,
                config: action.payload
            };
        }
        default:
            return state;
    }
}